// extracted by mini-css-extract-plugin
export default {"container":"employeeSettings_container__999ZQ","linksWrapper":"employeeSettings_linksWrapper__3n5pH","linkWrapper":"employeeSettings_linkWrapper__qjncu"};